import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {ConstituentsPref} from '../constants';

export const consituentClipsEnabled = () =>
	getPreference(ConstituentsPref.CLIPS_ENABLED, true);
